import { render, staticRenderFns } from "./RecognitionHistory.vue?vue&type=template&id=39d4afe6&scoped=true&"
import script from "./RecognitionHistory.vue?vue&type=script&lang=js&"
export * from "./RecognitionHistory.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionHistory.vue?vue&type=style&index=0&id=39d4afe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4afe6",
  null
  
)

export default component.exports